<div class="app-container">
  <app-sidebar
    (newChat)="onNewChat()"
    (taskSelected)="onTaskSelected($event)">
  </app-sidebar>

  <div class="main-content">
    <div class="thread-header">
      <div class="thread-header-left">
        <div class="thread-title">
          <span>Chat</span>
        </div>
      </div>

      <div class="thread-header-right">
        <button
          mat-icon-button
          title="Open debug"
          [disabled]="!debugId"
          (click)="goToDebug()">
          <mat-icon>bug_report</mat-icon>
        </button>

        <button
          mat-icon-button
          title="Log out"
          (click)="logout()">
          <mat-icon>logout</mat-icon>
        </button>
      </div>
    </div>

    <app-chat (debugIdChanged)="onDebugIdChanged($event)"></app-chat>
  </div>
</div>

